export const setTheme = new RegExp('vipclub').test(window.location.pathname) ? 'lighter-gray': 'dark';
